export const TICKET_STATUSES = [
  {
    name: "Additional Time Needed",
    id: "Additional Time Needed",
    show: false,
    label: "Additional Time Needed",
  },
  {
    name: "BER Approved",
    id: "BER Approved",
    show: false,
    label: "BER Approved",
  },
  {
    name: "Buyout Requested",
    id: "Buyout Requested",
    show: false,
    label: "Buyout Requested",
  },
  {
    name: "Contact Customer",
    id: "Contact Customer",
    show: false,
    label: "Contact Customer",
  },
  {
    name: "Customer Reply",
    id: "Customer Reply",
    show: false,
    label: "Customer Reply",
  },
  {
    name: "Delayed - Pricing Requested",
    id: "Delayed - Pricing Requested",
    show: false,
    label: "Delayed - Pricing Requested",
  },
  {
    name: "Delayed - Repair Approved",
    id: "Delayed - Repair Approved",
    show: false,
    label: "Delayed - Repair Approved",
  },
  {
    name: "Delayed - Repair Request",
    id: "Delayed - Repair Request",
    show: false,
    label: "Delayed - Repair Request",
  },
  {
    name: "Denied - Return to Customer",
    id: "Denied - Return to Customer",
    show: false,
    label: "Denied - Return to Customer",
  },
  {
    name: "In Progress",
    id: "In Progress",
    show: false,
    label: "In Progress",
  },
  {
    name: "IW - Waiting on Part",
    id: "IW - Waiting on Part",
    show: false,
    label: "IW - Waiting on Part",
  },
  {
    name: "New",
    id: "New",
    show: false,
    label: "New",
  },
  {
    name: "Non-Conforming Product Received",
    id: "Non-Conforming Product Received",
    show: false,
    label: "Non-Conforming Product Received",
  },
  {
    name: "OW - Waiting on Part",
    id: "OW - Waiting on Part",
    show: false,
    label: "OW - Waiting on Part",
  },
  {
    name: "Part(s) Arrived",
    id: "Part(s) Arrived",
    show: false,
    label: "Part(s) Arrived",
  },
  {
    name: "Parts on Backorder",
    id: "Parts on Backorder",
    show: false,
    label: "Parts on Backorder",
  },
  {
    name: "Parts Requested",
    id: "Parts Requested",
    show: false,
    label: "Parts Requested",
  },
  {
    name: "Pending Courier Pick-up (Outbound)",
    id: "Pending Courier Pick-up (Outbound)",
    show: false,
    label: "Pending Courier Pick-up (Outbound)",
  },
  {
    name: "Pending Courier Delivery (Inbound)",
    id: "Pending Courier Delivery (Inbound)",
    show: false,
    label: "Pending Courier Delivery (Inbound)",
  },
  {
    name: "Pending QA",
    id: "Pending QA",
    show: false,
    label: "Pending QA",
  },
  {
    name: "Pending QA - No Repair Needed",
    id: "Pending QA - No Repair Needed",
    show: false,
    label: "Pending QA - No Repair Needed",
  },
  {
    name: "Pending Reassembly",
    id: "Pending Reassembly",
    show: false,
    label: "Pending Reassembly",
  },
  {
    name: "QA Review",
    id: "QA Review",
    show: false,
    label: "QA Review",
  },
  {
    name: "Ready For Invoicing",
    id: "Ready For Invoicing",
    show: false,
    label: "Ready For Invoicing",
  },
  {
    name: "Ready for Repair",
    id: "Ready for Repair",
    show: false,
    label: "Ready for Repair",
  },
  {
    name: "Ready for shipment",
    id: "Ready for shipment",
    show: false,
    label: "Ready for shipment",
  },
  {
    name: "Received",
    id: "Received",
    show: false,
    label: "Received",
  },
  {
    name: "Repair Complete",
    id: "Repair Complete",
    show: false,
    label: "Repair Complete",
  },
  {
    name: "Resolved",
    id: "Resolved",
    show: false,
    label: "Resolved",
  },
  {
    name: "Resolved - BER",
    id: "Resolved - BER",
    show: false,
    label: "Resolved - BER",
  },
  {
    name: "Resolved - Buyout",
    id: "Resolved - Buyout",
    show: false,
    label: "Resolved - Buyout",
  },
  {
    name: "Resolved - Canceled",
    id: "Resolved - Canceled",
    show: false,
    label: "Resolved - Canceled",
  },
  {
    name: "Resolved - CNR",
    id: "Resolved - CNR",
    show: false,
    label: "Resolved - CNR",
  },
  {
    name: "Resolved - Denied",
    id: "Resolved - Denied",
    show: false,
    label: "Resolved - Denied",
  },
  {
    name: "Resolved - NPF",
    id: "Resolved - NPF",
    show: false,
    label: "Resolved - NPF",
  },
  {
    name: "Resolved- Shipped",
    id: "Resolved- Shipped",
    show: false,
    label: "Resolved - Shipped",
  },
  {
    name: "Resolved - Unable To Repair",
    id: "Resolved - Unable To Repair",
    show: false,
    label: "Resolved - Unable To Repair",
  },
  {
    name: "Resolved - Undelivered",
    id: "Resolved - Undelivered",
    show: false,
    label: "Resolved - Undelivered",
  },
  {
    name: "Scheduled",
    id: "Scheduled",
    show: false,
    label: "Scheduled",
  },
  {
    name: "Shipping Label Sent",
    id: "Shipping Label Sent",
    show: false,
    label: "Shipping Label Sent",
  },
  {
    name: "Solder Queue",
    id: "Solder Queue",
    show: false,
    label: "Solder Queue",
  },
  {
    name: "Uploaded to Shipstore",
    id: "Uploaded to Shipstore",
    show: false,
    label: "Uploaded to Shipstore",
  },
  {
    name: "Waiting for Parts",
    id: "Waiting for Parts",
    show: false,
    label: "Waiting for Parts",
  },
  {
    name: "Waiting on BER Credit",
    id: "Waiting on BER Credit",
    show: false,
    label: "Waiting on BER Credit",
  },
  {
    name: "Waiting on Charger",
    id: "Waiting on Charger",
    show: false,
    label: "Waiting on Charger",
  },
  {
    name: "Waiting on Customer",
    id: "Waiting on Customer",
    show: false,
    label: "Waiting on Customer",
  },
];
